export const RECAP_REQUEST = 'RECAP_REQUEST'
export const RECAP_REQUEST_CUD = 'RECAP_REQUEST_CUD'
// get
export const GET_RECAP_SUCCESS = 'GET_RECAP_SUCCESS'
export const GET_RECAP_ERROR = 'GET_RECAP_ERROR'